import type { ContinuityTraversalStep } from "../../lib/continuityTraversalNav";
import {
  getAdjacentTraversalStepsInList,
  traversalStepsForSurface,
} from "../../lib/continuityTraversalNav";

export type ContinuityYouAreHereProps = {
  currentStep: ContinuityTraversalStep | null;
  /** Override layer title when hub or unmapped */
  layerTitle?: string;
};

export function ContinuityYouAreHere({ currentStep, layerTitle }: ContinuityYouAreHereProps) {
  const hostname =
    typeof globalThis !== "undefined" && "location" in globalThis
      ? (globalThis as unknown as { location: { hostname: string } }).location.hostname
      : "";
  const pathname =
    typeof globalThis !== "undefined" && "location" in globalThis
      ? (globalThis as unknown as { location: { pathname: string } }).location.pathname
      : "/";
  const visibleSteps = traversalStepsForSurface(hostname, pathname);
  const { previous, next } = getAdjacentTraversalStepsInList(currentStep, visibleSteps);
  const layer = layerTitle ?? currentStep?.layerTitle ?? "Continuity sequence";
  const stepLabel = currentStep
    ? `Step ${currentStep.index} · ${currentStep.shortLabel}`
    : "Sequence hub";

  let relation =
    "Canonical continuity: signal → preserve → represent → witness → inspect → replay → call. Each step builds on the last.";
  if (currentStep && previous && next) {
    relation = `Previous: ${previous.layerTitle}. Next: ${next.layerTitle}.`;
  } else if (currentStep && !previous && next) {
    relation = `Beginning of the sequence. Next: ${next.layerTitle}.`;
  } else if (currentStep?.id === "call") {
    relation = "Continuity sequence completed. This closes the narrative.";
  } else if (currentStep && previous && !next) {
    relation = `Previous: ${previous.layerTitle}. Final step in the public sequence.`;
  }

  return (
    <aside className="xo-you-are-here" aria-label="Continuity context">
      <p className="xo-you-are-here__eyebrow">You are here · {stepLabel}</p>
      <p className="xo-you-are-here__layer">Current layer: {layer}</p>
      <p className="xo-you-are-here__relation">{relation}</p>
    </aside>
  );
}
